import clientBusinessApi from "../../api/clientBusiness";
import locationApi from "../../api/location";
import moment from "moment";

// initial state
const state = {
  clientBusinesses: [],
  detailedClientBusiness: ""
};

const getters = {};

const actions = {
  getAll({ commit }, userId) {
    return clientBusinessApi.getAll(userId, clientBusinesses => {
      commit("setClientBusinesses", clientBusinesses);
    });
  },

  getAllPromisized({ commit }, userId) {
    return new Promise((resolve, reject) => {
      clientBusinessApi.getAll(
        userId,
        clientBusinesses => {
          commit("setClientBusinesses", clientBusinesses);
          resolve(clientBusinesses);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  getClientBusiness({ commit }, clientBusinessId) {
    return new Promise((resolve, reject) => {
      clientBusinessApi.get(
        clientBusinessId,
        clientBusiness => {
          commit("setDetailedClientBusiness", clientBusiness);
          resolve();
        },
        error => {
          console.log("couldnt get that clientBusiness");
          reject();
        }
      );
    });
  },

  getReviews({ commit }, params) {
    return new Promise((resolve, reject) => {
      clientBusinessApi.getReviews(
        params,
        reviews => {
          resolve(reviews);
        },
        error => {
          console.log("could not get reviews");
          reject();
        }
      );
    });
  },

  getReviewableEmployeesForLocation({ commit }, locationId) {
    return new Promise((resolve, reject) => {
      clientBusinessApi.getReviewableEmployeesForLocation(
        locationId,
        employees => {
          resolve(employees);
        },
        error => {
          console.log("could not get employees");
          reject();
        }
      );
    });
  },

  createLocationReviewRequest({ commit }, params) {
    return new Promise((resolve, reject) => {
      clientBusinessApi.createReviewRequest(
        params,
        request => {
          resolve(request);
        },
        error => {
          console.log("could not create request");
          reject(error);
        }
      );
    });
  },

  updateEvaluation({ commit }, params) {
    return new Promise((resolve, reject) => {
      clientBusinessApi.updateEvaluation(
        params,
        evaluation => {
          resolve(evaluation);
        },
        error => {
          console.log("could not create evaluation");
          reject(error);
        }
      );
    });
  },

  resendRequest({ commit }, request) {
    return new Promise((resolve, reject) => {
      clientBusinessApi.resendRequest(
        request,
        res => {
          resolve(res);
        },
        error => {
          console.log("could not re-send request");
          reject(error);
        }
      );
    });
  },

  getReviewDraft({ commit }, shareKey) {
    return new Promise((resolve, reject) => {
      clientBusinessApi.getReviewDraft(
        shareKey,
        res => {
          resolve(res);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  update({ dispatch, commit }, idFieldData) {
    return new Promise((resolve, reject) => {
      clientBusinessApi.update(
        idFieldData,
        clientBusiness => {
          commit("updateClientBusiness", clientBusiness);
          commit("setDetailedClientBusiness", clientBusiness);
          resolve();
        },
        error => {
          console.log("Something broke at the API");
          reject();
        }
      );
    });
  },

  create({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      clientBusinessApi.create(
        params,
        clientBusiness => {
          resolve(clientBusiness);
        },
        error => {
          console.log("Something broke at the API");
          reject();
        }
      );
    });
  },

  locationUpdate({ dispatch, commit }, idFieldData) {
    return new Promise((resolve, reject) => {
      locationApi.update(
        idFieldData,
        location => {
          dispatch("refreshLocation", location);
          resolve(location);
        },
        error => {
          console.log("Something broke at the API");
          reject();
        }
      );
    });
  },

  refreshLocation({ dispatch, commit }, location) {
    commit("refreshLocation", location);
  }
};

const mutations = {
  setClientBusinesses(state, clientBusinesses) {
    state.clientBusinesses = clientBusinesses;
    //state.available = Object.assign({}, state.available, shifts) // Works...
    //Object.assign(state.available, shifts) // NO! doesn't work!
  },

  setDetailedClientBusiness(state, clientBusiness) {
    state.detailedClientBusiness = clientBusiness;
  },

  updateClientBusiness(state, clientBusiness) {
    state.clientBusinesses = [
      ...state.clientBusinesses.filter(c => c.id !== clientBusiness.id),
      clientBusiness
    ];
  },

  refreshLocation(state, location) {
    state.detailedClientBusiness.locations = [
      ...state.detailedClientBusiness.locations.filter(
        l => l.id !== location.id
      ),
      location
    ];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
